// Central content + SEO data for Super 8 by Wyndham Ottawa, Kansas
export const HOTEL = {
  name: "Super 8 by Wyndham Ottawa",
  shortName: "Super 8 Ottawa",
  brand: "Super 8 by Wyndham",
  addressLine: "2315 South Oak",
  city: "Ottawa",
  state: "KS",
  stateName: "Kansas",
  zip: "66067",
  country: "US",
  fullAddress: "2315 South Oak, Ottawa, KS 66067",
  phone: "+1-785-242-5551",
  phoneDisplay: "(785) 242-5551",
  email: "Super8ottawa@gmail.com",
  lat: 38.5798,
  lng: -95.2699,
  bookUrl:
    "https://www.wyndhamhotels.com/super-8/ottawa-kansas/super-8-ottawa/overview?utm_source=organic&utm_medium=website&utm_campaign=hopbots-+website",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Super+8+by+Wyndham+Ottawa,2315+South+Oak,Ottawa,KS+66067",
  mapEmbed:
    "https://www.google.com/maps?q=Super+8+by+Wyndham+Ottawa,2315+South+Oak,Ottawa,KS+66067&output=embed",
};

const WP = "/images";
// Property images are self-hosted in /public/images (recovered originals of the real
// Super 8 Ottawa photos). Hotlinking the old WordPress domain broke once it was repointed.
export const IMG = {
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_c6e7cf97-071e-492d-8917-dffccd408a67/artifacts/asaizjok_Super%208%20wyndham%20logo.jpeg",
  exterior: `${WP}/exterior.jpg`,
  exterior2: `${WP}/exterior2.jpg`,
  exterior3: `${WP}/exterior3.jpg`,
  motel: `${WP}/exterior2.jpg`,
  pool: `${WP}/pool.jpg`,
  pool2: `${WP}/pool2.jpg`,
  poolKids: `${WP}/pool-kids.jpg`,
  breakfast: `${WP}/breakfast.jpg`,
  doubleQueen: `${WP}/room-double-queen.jpg`,
  roomKing: `${WP}/room-king.jpg`,
  affordableRoom: `${WP}/room-king.jpg`,
  senior: `${WP}/room-senior.jpg`,
  // aliases (all map to real self-hosted hotel photos)
  roomWide: `${WP}/room-king.jpg`,
  suite: `${WP}/room-senior.jpg`,
  desk: `${WP}/room-king.jpg`,
  trail: `${WP}/exterior.jpg`,
  downtown: `${WP}/exterior2.jpg`,
  campus: `${WP}/exterior3.jpg`,
  lake: `${WP}/pool2.jpg`,
  lake2: `${WP}/pool-kids.jpg`,
  // representative concept imagery (generic — not a specific place)
  truck: "https://images.pexels.com/photos/10359129/pexels-photo-10359129.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  truck2: "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { label: "Rooms", to: "/rooms" },
  { label: "Amenities", to: "/amenities" },
  { label: "Indoor Pool", to: "/indoor-pool" },
  { label: "Truck Parking", to: "/truck-parking" },
  { label: "Extended Stay", to: "/extended-stay" },
  { label: "Attractions", to: "/attractions" },
  { label: "FAQ", to: "/faq" },
];

export const AMENITIES = [
  { name: "Indoor Heated Pool", icon: "Waves", desc: "Year-round heated indoor swimming — rain, snow or shine." },
  { name: "Free SuperStart Breakfast", icon: "Coffee", desc: "Complimentary morning spread — waffles, cereal, fruit, muffins & bagels." },
  { name: "Free High-Speed WiFi", icon: "Wifi", desc: "Fast, reliable internet in every room and public space." },
  { name: "Large Truck & RV Parking", icon: "Truck", desc: "Free oversized parking with outside electrical outlets." },
  { name: "Bus & Motorcoach Parking", icon: "Bus", desc: "Room for tour buses and group travel vehicles." },
  { name: "Guest Laundry", icon: "WashingMachine", desc: "On-site coin laundry for longer stays." },
  { name: "24-Hour Front Desk", icon: "Clock", desc: "Someone is always here to help, day or night." },
  { name: "Express Check-out", icon: "Zap", desc: "Skip the line and get back on the road faster." },
  { name: "Accessible Rooms", icon: "Accessibility", desc: "Accessible bathrooms and wider doorways available in select rooms." },
  { name: "Elevator Access", icon: "ArrowUpDown", desc: "Easy access to all floors." },
  { name: "In-Room Microwave", icon: "Microwave", desc: "Most rooms include a microwave." },
  { name: "Mini-Refrigerator", icon: "Refrigerator", desc: "Keep drinks and leftovers cold in most rooms." },
  { name: "Flat-Screen HDTV", icon: "Tv", desc: "Cable HDTV in every guest room." },
  { name: "Coffee Maker", icon: "Coffee", desc: "In-room coffee to start your morning." },
  { name: "Non-Smoking Rooms", icon: "Ban", desc: "Fresh, clean, smoke-free accommodations." },
  { name: "Ice & Vending", icon: "Snowflake", desc: "Ice machines and vending on-site." },
];

export const ROOMS = [
  {
    slug: "king-room",
    name: "King Room",
    beds: "1 King Bed",
    sleeps: "Sleeps 2",
    image: IMG.roomWide,
    short: "A spacious king retreat for couples and solo travelers who want room to spread out.",
    desc: "Unwind in a bright, freshly kept King room built for restful nights off I-35. The pillow-top king bed anchors a comfortable space with a dedicated work area, flat-screen HDTV, and free high-speed WiFi throughout.",
    features: ["1 King Bed", "Work desk & chair", "Microwave", "Mini-refrigerator", "Coffee maker", "Flat-screen HDTV", "Free WiFi", "Private bathroom"],
  },
  {
    slug: "double-queen-room",
    name: "Double Queen Room",
    beds: "2 Queen Beds",
    sleeps: "Sleeps 4",
    image: IMG.doubleQueen,
    short: "Two queen beds — the go-to choice for families, friends, and traveling crews.",
    desc: "Our most popular room gives families and work crews plenty of space with two comfortable queen beds. Enjoy a microwave, mini-refrigerator, coffee maker, and HDTV, plus free WiFi and easy parking right outside.",
    features: ["2 Queen Beds", "Microwave", "Mini-refrigerator", "Coffee maker", "Flat-screen HDTV", "Free WiFi", "Work area", "Private bathroom"],
  },
  {
    slug: "jacuzzi-suite",
    name: "Jacuzzi Suite",
    beds: "1 King Bed + Jetted Tub",
    sleeps: "Sleeps 2",
    image: IMG.suite,
    short: "A jetted-tub suite for anniversaries, getaways, and a little extra comfort.",
    desc: "Treat yourself to our Jacuzzi Suite featuring a private in-room jetted tub, a king bed, and an elevated sense of space. Perfect for celebrations, romantic weekends, or simply rewarding yourself after a long drive.",
    features: ["1 King Bed", "In-room jetted tub", "Microwave", "Mini-refrigerator", "Coffee maker", "Flat-screen HDTV", "Free WiFi", "Extra seating"],
  },
  {
    slug: "family-room",
    name: "Family Room",
    beds: "2 Queen Beds",
    sleeps: "Sleeps 4",
    image: IMG.affordableRoom,
    short: "Room for the whole crew, steps from the indoor pool and free breakfast.",
    desc: "Traveling with kids? Our family-friendly rooms pair two queen beds with everything you need for an easy stay — plus free breakfast and an indoor pool the kids will love, rain or shine.",
    features: ["2 Queen Beds", "Microwave", "Mini-refrigerator", "Coffee maker", "Flat-screen HDTV", "Free WiFi", "Steps from indoor pool", "Private bathroom"],
  },
  {
    slug: "business-room",
    name: "Business Room",
    beds: "1 King Bed",
    sleeps: "Sleeps 2",
    image: IMG.desk,
    short: "A quiet, productive base with a dedicated workspace and fast WiFi.",
    desc: "Built for the working traveler, our Business room offers a proper desk, strong free WiFi, express check-out, and a quiet night's sleep so you're sharp for your next meeting or job site.",
    features: ["1 King Bed", "Large work desk", "Free high-speed WiFi", "Microwave & fridge", "Coffee maker", "Flat-screen HDTV", "Express check-out", "24-hour front desk"],
  },
  {
    slug: "accessible-room",
    name: "Accessible Room",
    beds: "1 King or 2 Queen Beds",
    sleeps: "Sleeps 2-4",
    image: IMG.senior,
    short: "Accessible comfort with an accessible bathroom and wider doorways in select rooms.",
    desc: "Our accessible rooms are designed for ease and independence, with accessible bathroom features and wider doorways available in select rooms. Accessibility layouts vary by room, so please call us before booking and we'll confirm the exact features you need.",
    features: ["Accessible bathroom", "Wider doorways (select rooms)", "Elevator access", "Microwave & fridge", "Coffee maker", "Flat-screen HDTV", "Free WiFi", "Call to confirm your needs"],
  },
];

export const REVIEWS = [
  { name: "John H.", place: "Perryton, Texas", stars: 5, text: "I've stayed here a couple of times and rooms are always clean and comfortable! They have truck parking and an Applebee's restaurant within walking distance." },
  { name: "Judith", place: "Glen Rose, Texas", stars: 5, text: "Great value. Clean room, friendly staff, great beds, pretty good breakfast and very good WiFi. And it didn't break the bank!" },
  { name: "Lester", place: "Larned, Kansas", stars: 5, text: "We love coming here because of the friendly service! We have a family reunion close by every year and this place lets us relax and sleep well before our day starts." },
  { name: "Shawn", place: "Somerset, Pennsylvania", stars: 4, text: "This hotel not only had truck parking — I was impressed with the room and facility overall for the location." },
  { name: "Jessica", place: "Endicott, New York", stars: 5, text: "Very good price, nice room, and the manager was very accommodating. There was work being done on the lot and he called later just to be sure everything went well." },
  { name: "Terry", place: "Broken Arrow, Oklahoma", stars: 4, text: "Great for the money. Hotel was clean and the front desk was friendly. Breakfast had cereal, waffles and bagels." },
];

export const ATTRACTIONS = [
  { name: "Prairie Spirit Trail", cat: "Outdoors", dist: "5 min", image: IMG.trail, desc: "A scenic rail-trail for cycling, running and walking that runs through Ottawa and rolls south across the Kansas prairie." },
  { name: "Ottawa University", cat: "University", dist: "6 min", image: IMG.campus, desc: "Historic private university in the heart of Ottawa — perfect for campus visits, sporting events and graduations." },
  { name: "Downtown Ottawa", cat: "Shopping & Dining", dist: "7 min", image: IMG.downtown, desc: "A charming, walkable historic main street lined with restaurants, coffee shops, antiques and local boutiques." },
  { name: "Old Depot Museum", cat: "History", dist: "8 min", image: IMG.downtown, desc: "Explore Franklin County history and railroad exhibits inside a beautifully preserved historic Santa Fe railroad depot." },
  { name: "Pomona Lake", cat: "Lake & Fishing", dist: "25 min", image: IMG.lake, desc: "Boating, fishing and camping around a scenic reservoir — one of the best fishing spots in the region." },
  { name: "Hillsdale Lake", cat: "Lake & Fishing", dist: "30 min", image: IMG.lake2, desc: "A local favorite for bass fishing, boating and lakeside hiking within easy reach of the hotel." },
  { name: "Kanza Park Disc Golf", cat: "Outdoors", dist: "10 min", image: IMG.trail, desc: "A nine-hole disc golf course and green space that's great for an easy afternoon outdoors." },
  { name: "City Park", cat: "Parks", dist: "7 min", image: IMG.downtown, desc: "A classic downtown park in Ottawa for picnics, playgrounds and community events." },
  { name: "Forest Park", cat: "Parks", dist: "9 min", image: IMG.trail, desc: "Wooded trails and quiet nature spots for a relaxed walk close to town." },
  { name: "Ottawa Antique Mall", cat: "Shopping", dist: "8 min", image: IMG.downtown, desc: "Hunt for vintage treasures and collectibles across a large local antique marketplace." },
  { name: "Ottawa Municipal Auditorium", cat: "Events", dist: "8 min", image: IMG.downtown, desc: "A historic venue hosting concerts, performances and community gatherings." },
  { name: "University of Kansas (Lawrence)", cat: "University", dist: "35 min", image: IMG.campus, desc: "The Jayhawks' iconic campus and downtown Lawrence — a short, scenic drive north of the hotel." },
  { name: "Baker University (Baldwin City)", cat: "University", dist: "25 min", image: IMG.campus, desc: "One of Kansas' oldest universities, ideal for campus tours, alumni weekends and family visits." },
  { name: "Dietrich Cabin", cat: "History", dist: "7 min", image: IMG.downtown, desc: "A restored pioneer-era log cabin in City Park offering a window into early Kansas frontier life." },
];

export const CITIES = [
  { name: "Ottawa, KS", dist: "0 min", desc: "Our home base — right off I-35 near universities, the Prairie Spirit Trail and downtown Ottawa." },
  { name: "Lawrence, KS", dist: "35 min", desc: "Home of the University of Kansas. The closest full-service comfortable stay for KU visitors and game days." },
  { name: "Baldwin City, KS", dist: "25 min", desc: "Baker University and the Maple Leaf Festival — a quick drive from your room." },
  { name: "Williamsburg, KS", dist: "15 min", desc: "A convenient I-35 stop for travelers heading through east-central Kansas." },
  { name: "Richmond, KS", dist: "15 min", desc: "Small-town Franklin County charm just minutes from the hotel." },
  { name: "Pomona, KS", dist: "20 min", desc: "Gateway to Pomona Lake State Park and some of the area's best fishing." },
  { name: "Princeton, KS", dist: "12 min", desc: "Close to Princeton's industrial and agricultural employers along the I-35 corridor." },
  { name: "Rantoul, KS", dist: "18 min", desc: "A quiet nearby community within easy commuting distance." },
  { name: "Lane, KS", dist: "25 min", desc: "Rural Franklin County destination close to our Ottawa location." },
  { name: "Lyndon, KS", dist: "25 min", desc: "The Osage County seat, a short drive west via US-75." },
];

export const FAQS = [
  { c: "Breakfast", q: "Is breakfast included at Super 8 Ottawa?", a: "Yes. Every stay includes our free SuperStart breakfast with items like waffles, cereal, fresh fruit, muffins and bagels, plus coffee and juice — at no extra charge." },
  { c: "Breakfast", q: "What time is breakfast served?", a: "Breakfast is served every morning in our lobby breakfast area. Exact hours can vary seasonally, so please confirm times with the front desk at check-in." },
  { c: "Pool", q: "Do you have an indoor swimming pool?", a: "Yes — we feature a heated indoor pool open year-round, so you can swim regardless of the Kansas weather. It's a favorite with families and a great way to unwind after a long drive." },
  { c: "Pool", q: "Is the pool accessible?", a: "Our hotel offers elevator access and accessible rooms. If you have specific pool accessibility needs, please call the front desk before your visit and we'll do our best to accommodate you." },
  { c: "Pool", q: "What are the pool hours?", a: "The indoor pool is open daily. Posted hours are available at the front desk and near the pool entrance." },
  { c: "Truck Parking", q: "Do you have truck and RV parking?", a: "Absolutely. We offer free large-vehicle parking that accommodates semi-trucks, RVs and buses, with outside electrical outlets — one of the reasons drivers and crews choose us." },
  { c: "Truck Parking", q: "Can tour buses and motorcoaches park here?", a: "Yes, our lot has room for tour buses and motorcoaches. For large groups we recommend calling ahead so we can prepare for your arrival." },
  { c: "WiFi", q: "Is WiFi free?", a: "Yes, free high-speed WiFi is included with every stay, throughout all guest rooms and public areas." },
  { c: "Check-in", q: "What are your check-in and check-out times?", a: "Standard check-in is in the mid-afternoon and check-out is late morning. Early check-in and late check-out may be available on request — just ask the front desk." },
  { c: "Check-in", q: "Is the front desk staffed 24 hours?", a: "Yes, our front desk is staffed 24 hours a day, so there's always someone to help whether you arrive early or late." },
  { c: "Cancellation", q: "What is your cancellation policy?", a: "Cancellation terms depend on the rate you book. When you reserve directly through our official Wyndham booking page, the full policy is shown before you confirm." },
  { c: "Accessibility", q: "Do you offer ADA-accessible rooms?", a: "Yes. We offer accessible rooms with features such as accessible bathrooms and wider doorways in select rooms, plus elevator access. Accessibility features vary by room, so please call us to confirm the exact features you need before booking." },
  { c: "Parking", q: "Is parking free?", a: "Yes, on-site parking is free for all guests, including oversized and large-vehicle parking." },
  { c: "Laundry", q: "Is there guest laundry on-site?", a: "Yes, we provide on-site guest laundry facilities — convenient for extended stays and long road trips." },
  { c: "Rooms", q: "What room types do you offer?", a: "We offer King rooms, Double Queen rooms, Family rooms, Business rooms, Jacuzzi suites and accessible rooms. Most rooms include a microwave, mini-refrigerator and flat-screen HDTV." },
  { c: "Rooms", q: "Are your rooms non-smoking?", a: "Yes, we offer clean, fresh non-smoking rooms." },
  { c: "Rooms", q: "Do rooms have a microwave and refrigerator?", a: "Most of our rooms include a microwave and mini-refrigerator, along with a coffee maker and flat-screen HDTV." },
  { c: "Universities", q: "How close are you to Ottawa University?", a: "Ottawa University is only a few minutes' drive from the hotel, making us a convenient choice for campus visits, sporting events and graduations." },
  { c: "Universities", q: "How far is the University of Kansas?", a: "The University of Kansas in Lawrence is roughly a 35-minute drive north — a comfortable, affordable alternative to staying in Lawrence on busy game and event weekends." },
  { c: "Universities", q: "Is Baker University nearby?", a: "Yes, Baker University in Baldwin City is about 25 minutes away." },
  { c: "Restaurants", q: "Are there restaurants within walking distance?", a: "Yes. Guests regularly mention an Applebee's within walking distance, and there are additional dining options nearby along the I-35 corridor and in downtown Ottawa." },
  { c: "Business Travel", q: "Do you cater to business and government travelers?", a: "We do. With fast free WiFi, in-room workspaces, express check-out and a 24-hour front desk, we're well suited for contractors, sales reps, engineers and government per-diem travelers." },
  { c: "Group Bookings", q: "Can I book a block of rooms for a group?", a: "Yes. We welcome sports teams, wedding blocks, family reunions, church groups and corporate groups. Call us directly to arrange group rates and room blocks." },
  { c: "Long-Term Stay", q: "Do you offer weekly or extended-stay rates?", a: "Yes — with guest laundry, in-room refrigerators and microwaves, we're a comfortable base for weekly and monthly stays. Call the hotel directly for extended-stay pricing." },
  { c: "Long-Term Stay", q: "Are you a good fit for construction and travel crews?", a: "Very much so. Free large-vehicle parking, free breakfast, guest laundry and easy highway access make us a favorite for construction, utility, pipeline and project crews." },
  { c: "Road Trips", q: "How close are you to I-35?", a: "We're located right off I-35, making us an easy and convenient stop for road trips through east-central Kansas." },
  { c: "Pets", q: "Are pets allowed?", a: "Pet policies can change, so please contact the hotel directly to confirm current pet availability, fees and any restrictions before you travel." },
  { c: "Payment", q: "How do I get the best rate?", a: "Booking directly through our official Wyndham reservation page is the best way to get our best available rate — plus you can earn Wyndham Rewards points on your stay." },
];

export const MANIFESTO = [
  { n: "01", title: "Book Direct, Save More", body: "Skip the third-party markups. Reserve through the official Wyndham engine for the best available rate and Wyndham Rewards points on every stay." },
  { n: "02", title: "Right Off I-35", body: "An effortless highway exit near Ottawa University and the Prairie Spirit Trail — the easiest arrival and departure in town." },
  { n: "03", title: "Built for Every Traveler", body: "Families, work crews, truckers, business travelers and weekend explorers all find their place here — with parking to match." },
  { n: "04", title: "Comfort That's Consistent", body: "Clean rooms, friendly 24-hour service, free breakfast and free WiFi. The kind of dependable stay guests come back for, year after year." },
];

// 150+ future blog topics
export const BLOG_TOPICS = [
  "Things To Do in Ottawa, KS: The Complete Local Guide",
  "A Perfect Weekend in Ottawa, Kansas",
  "The Best Restaurants Near Super 8 Ottawa",
  "Fishing Guide: Pomona Lake vs. Hillsdale Lake",
  "The Ultimate Prairie Spirit Trail Cycling Guide",
  "Visiting the University of Kansas: A Parent's Guide",
  "Ottawa University Visitor Guide: Where To Stay & What To See",
  "Baker University & Baldwin City: A Day-Trip Itinerary",
  "Business Travel Tips for I-35 Road Warriors",
  "The Best Kansas Road Trips Starting in Ottawa",
  "Why an Indoor Pool Makes Winter Travel Better",
  "A Truck Driver's Guide to Overnight Parking in Ottawa, KS",
  "Lodging for Construction Crews: What To Look For",
  "A Family Weekend Itinerary in Ottawa, Kansas",
  "The Best Local Coffee Shops Near the Hotel",
  "Kansas Road Trips: Ottawa to the Flint Hills",
  "How To Plan a Family Reunion in Ottawa, KS",
  "Game-Day Guide: Staying Near KU Without Paying Lawrence Prices",
  "Disc Golf at Kanza Park: A Beginner's Guide",
  "Exploring Historic Downtown Ottawa",
  "The Old Depot Museum: What To Know Before You Go",
  "Antiquing in Ottawa: Best Shops & Finds",
  "Where To Watch the Sunset Near Ottawa, KS",
  "Camping Near Ottawa: Pomona State Park Guide",
  "The Maple Leaf Festival in Baldwin City",
  "Extended-Stay Living: Making a Hotel Feel Like Home",
  "Travel Nurse Housing in East-Central Kansas",
  "Best Free Things To Do in Ottawa, Kansas",
  "A Cyclist's Weekend on the Prairie Spirit Trail",
  "Pet-Friendly Travel Tips for the I-35 Corridor",
  "Winter Getaways: Indoor Pool Hotels in Kansas",
  "The Best Breakfast Spots (Besides Ours) in Ottawa",
  "Planning a Wedding Room Block in Ottawa, KS",
  "Church Group Travel: Organizing a Retreat in Kansas",
  "Sports Team Travel: Booking Blocks for Tournaments",
  "Motorcoach Tour Stops in East-Central Kansas",
  "A Guide to Franklin County History",
  "Birdwatching Around Hillsdale Lake",
  "The Best Hiking Trails Near Ottawa, KS",
  "How To Beat the Heat: Summer Family Activities in Ottawa",
  "Rainy Day Activities in Ottawa, Kansas",
  "Ottawa, KS for First-Time Visitors",
  "Where To Eat After a Long Drive on I-35",
  "The Wyndham Rewards Guide for Frequent Travelers",
  "Direct Booking vs. OTAs: Why It Pays To Book Direct",
  "Packing List for a Kansas Road Trip",
  "Best Photo Spots in and Around Ottawa",
  "A Guide to Ottawa's Annual Events & Festivals",
  "Golfing Near Ottawa, Kansas",
  "Weekend Cycling Loops from the Prairie Spirit Trail",
  "Kid-Friendly Ottawa: A Day of Fun",
  "The History of the Santa Fe Railroad in Ottawa",
  "Where To Fuel Up & Rest Along I-35 in Kansas",
  "The Best Time of Year To Visit Ottawa, KS",
  "Understanding Extended-Stay Hotel Amenities",
  "How Truckers Choose the Right Overnight Stop",
  "A Guide to Ottawa's Parks: City Park & Forest Park",
  "Planning a College Move-In Weekend at KU",
  "Fall Foliage Drives Around Franklin County",
  "The Best Fishing Bait for Pomona Lake Bass",
  "How To Make the Most of a Free Hotel Breakfast",
  "Budget Travel Tips for Families in Kansas",
  "A Weekend Guide for Wedding Guests in Ottawa",
  "Graduation Weekend at Ottawa University: Where To Stay",
  "The Ultimate Guide to I-35 Rest Stops in Kansas",
  "Corporate Travel Booking Made Simple",
  "Why Free Parking Matters for Road Trippers",
  "A Guide to Accessible Travel in Ottawa, KS",
  "Senior-Friendly Travel: Ottawa, Kansas",
  "Long-Haul Driver Wellness on the Road",
  "The Best Local Diners in Franklin County",
  "How To Spend 48 Hours in Lawrence, Kansas",
  "Exploring the Flint Hills from Ottawa",
  "A Guide to Ottawa's Coffee Culture",
  "The Best Playgrounds for Traveling Families",
  "Historic Architecture of Downtown Ottawa",
  "Cycling Gear Checklist for the Prairie Spirit Trail",
  "How To Plan a Multi-Family Reunion Trip",
  "The Traveler's Guide to Kansas Weather",
  "Where To Buy Local Souvenirs in Ottawa",
  "A Guide to Ottawa's Live Music & Auditorium Events",
  "Travel Tips for Utility and Pipeline Crews",
  "Making Business Trips More Comfortable",
  "The Best Scenic Drives Around Ottawa, KS",
  "A Guide to Fishing Licenses in Kansas",
  "Family Movie Nights: Hotel Stay Edition",
  "How To Choose a Hotel for a Sports Tournament",
  "The Benefits of Staying Near the Highway",
  "A First-Timer's Guide to Disc Golf",
  "Ottawa's Best Ice Cream & Sweet Spots",
  "How To Save on College Visit Travel",
  "The Insider's Guide to Wyndham Rewards Perks",
  "A Guide to RV Travel Through Kansas",
  "Where To Walk Your Dog Near the Hotel",
  "Planning a Stress-Free Group Getaway",
  "The Best Sunrise Spots Around Ottawa",
  "A Traveler's Guide to Kansas BBQ",
  "How To Stay Productive on a Business Trip",
  "The Ottawa, KS Holiday Season Guide",
  "Weekend Warrior: Cycling the Full Prairie Spirit Trail",
  "A Guide to Baldwin City's Historic Downtown",
  "The Best Lakeside Picnic Spots Near Ottawa",
  "How Families Can Make the Most of an Indoor Pool",
  "Road-Trip Games for the Whole Family",
  "A Guide to Traveling with a Large Group",
  "The Best Times To Book Direct for Lower Rates",
  "Understanding Hotel Room Types: Which Is Right for You?",
  "The Ultimate Ottawa, KS Foodie Crawl",
  "How To Plan a Corporate Retreat in Kansas",
  "A Guide to the Franklin County Fair",
  "Where To Stargaze Near Ottawa, Kansas",
  "The Traveler's Checklist for Extended Stays",
  "How To Choose Truck-Friendly Lodging",
  "A Guide to Kansas State Parks Near Ottawa",
  "The Best Walking Tours of Downtown Ottawa",
  "How To Make a Hotel Stay Kid-Approved",
  "A Seasonal Guide to Prairie Spirit Trail Wildlife",
  "The Business Traveler's Guide to Ottawa, KS",
  "How To Plan a Motorcycle Road Trip Through Kansas",
  "The Best Weekend Escapes from Kansas City",
  "A Guide to Local Farmers Markets Near Ottawa",
  "How To Get the Most From a 24-Hour Front Desk",
  "The Complete Guide to Ottawa University Athletics Weekends",
  "Tips for Comfortable Long-Term Hotel Living",
  "A Guide to Fishing Tournaments at Hillsdale Lake",
  "The Best Day Trips from Ottawa, Kansas",
  "How To Travel Sustainably on I-35",
  "A Guide to Ottawa's Public Art & Murals",
  "The Best Coffee for the Road: Local Roasters",
  "How Crews Save Money With Direct Hotel Booking",
  "A Guide to Winter Driving Safety on I-35",
  "The Best Family-Friendly Restaurants in Ottawa",
  "How To Plan the Perfect Anniversary Getaway",
  "A Guide to the Dietrich Cabin & Pioneer History",
  "The Traveler's Guide to Ottawa's Antique Scene",
  "How To Pick the Right Room for a Family of Four",
  "A Guide to Spring Wildflowers on the Prairie",
  "The Best Ottawa, KS Experiences for Under $20",
  "How To Book a Group Block Without the Headache",
  "A Guide to Nearby Golf Courses",
  "The Best Times To Visit Kansas Lakes",
  "How To Make a Business Trip Feel Like a Break",
  "A Guide to Ottawa's Coffee-and-Cycling Combo",
  "The Ultimate Guide to Free Hotel Amenities",
  "How To Plan a College Tour Road Trip in Kansas",
  "A Guide to Traveling with Kids on a Budget",
  "The Best Local Bakeries Near Super 8 Ottawa",
  "How To Choose a Hotel for a Wedding Weekend",
  "A Guide to Ottawa's Seasonal Festivals",
  "The Road Tripper's Guide to East-Central Kansas",
];
